<template>
  <BittsModal
    variant="confirm"
    title="Exit without saving"
    description="You've made changes that haven't been saved. Are you sure you want to exit without saving?"
    primary-button-text="Exit"
    primary-button-type="danger"
    secondary-button-text="Cancel"
    :action-loading="false"
    @action="handleDiscardChanges"
    @closed="$emit('closed')"
  />
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

const emit = defineEmits<(e: 'discard' | 'closed') => void>();

function handleDiscardChanges() {
  emit('discard');
}
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.o-bitts-modal:deep()
  dialog
  .o-bitts-modal__header
  .o-bitts-modal__description {
  @apply m-0;
}
</style>
